import * as React from 'react';
import { inject } from 'mobx-react';
import { RouteProps } from 'react-router';
import { injectIntl } from 'react-intl';

import HomeComponent from '../../components/home/home';
import Button, { ButtonType } from '../../components/button/button';
import Image, { ImageType } from '../../components/image/image';

import { ROUTE_START } from '../../RouteList';
import messages from './messages';
import FooterBottom from '../../components/layout/footer-bottom';
import { APP_TITLE } from '../../constants';

@inject('routing', 'dataStore')
class Home extends React.Component<RouteProps & any, any> {
  public render() {
    const {
      dataStore,
      intl,
      routing: { push }
    } = this.props;
    return (
      <React.Fragment>
        <HomeComponent
          title={intl.formatMessage(messages.title)}
          subTitle={intl.formatMessage(messages.header)}
          content={intl.formatMessage(messages.text)}
        >
          <Button
            type={ButtonType.primaryLarge}
            label={intl.formatMessage(messages.start)}
            onClick={() => {
              if (!dataStore.isPrivate) {
                dataStore.reset();
              }

              push(ROUTE_START);
            }}
          />
        </HomeComponent>
        {/* </div> */}
        <FooterBottom>
          <Image
            type={ImageType.homeRocket}
            imgSrc="/images/svg/intro-rocket-clouds.svg"
            alt={'rocket'}
          />
          <Image
            type={ImageType.homeLogos}
            imgSrc={
              APP_TITLE === 'Hylyght'
                ? `/images/png/home-sponsors.png`
                : `/images/png/home-sponsors-${intl.locale}.png`
            }
            alt={intl.formatMessage(messages.logos)}
          />
        </FooterBottom>
      </React.Fragment>
    );
  }
}

export default injectIntl(Home);



// WEBPACK FOOTER //
// ./src/containers/home/Home.tsx